import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LoginRecoverForm from 'components/auth/LoginRecoverForm';
import Footer from 'pages/Login/footer';
import { history } from 'state/store';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import routes from 'utils/routes';
import authSelectors from 'state/auth/selectors';
import { OnTruckLogo } from 'refactored/ui/icons';

const LoginRecover = ({ className, match }) => {
  const { t } = useTranslation('Login');
  const userIsLogged = useSelector(authSelectors.userIsLogged);

  useEffect(() => {
    if (userIsLogged) {
      history.push(routes.orders.default);
    }
  }, [userIsLogged]);

  if (userIsLogged) return null;

  return (
    <div className={`${className} public-page`} data-testid="login-recover">
      <section className="main" role="main">
        <button className="logo" onClick={() => history.push(routes.login)}>
          <OnTruckLogo />
        </button>
        <LoginRecoverForm match={match} />
      </section>
      <Footer t={t} />
    </div>
  );
};

LoginRecover.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

LoginRecover.defaultProps = {
  className: '',
  t: (t) => t,
  match: {},
};

export default LoginRecover;
